
import { defineComponent, inject, Ref } from "vue";
import { terms_key } from "@/symbols";

export default defineComponent({
  setup() {
    const open_terms = inject(terms_key) as Ref<boolean>;
    return { open_terms };
  },
});
